<template>
  <div v-if="items.length" class="items">
    <section>
      <v-container class="overflow-hidden container-large">
        <TitleWidget small>
          {{ upTitle }}
        </TitleWidget>
        <TitleWidget>
          {{ title }}
        </TitleWidget>
        <div class="courses mt-10">
          <template v-for="(item, keyItems) in items">
            <div :key="keyItems">
              <CourseCard v-bind="item" />
            </div>
          </template>
        </div>
      </v-container>
    </section>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import CourseCard from "../cards/CourseCard.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "courses",
  path: "/cursos",
};

const _data = {
  upTitle: "Conheça",
  title: "Nossos Cursos",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ img, title }) => ({
        img: img.featured,
        title,
        to: `${_config.path}/${formatToURL(title)}`,
      }));
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    CourseCard,
  },
};
</script>

<style lang="scss" scoped>
.courses {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  & .item {
    width: 250px;
    border-radius: 50% !important;
  }
}
</style>
